import React from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";

const PageHeader = (props) => {
  return (
    <div className=" w-full h-[64px]">
      <div className="flex px-6 pt-2">
        <a href="/" className="dark:text-white flex text-[24px]  w-[25%] md:w-[15%]   lg:w-[10%]">
        <MdKeyboardArrowLeft style={{fontSize:"32px"}} className="text-[#17A6DB] dark:text-[#30dada]" />{props.back}
        </a>
        <p className="dark:text-white text-[24px] w-[75%] md:w-[85%] lg:w-[90%]"> {props.text}</p>
      </div>
    </div>
  );
};

export default PageHeader;
